module.exports = __webpack_public_path__ + "static/media/provozovna (1).963d45ca.png";